import { defineMessages } from 'react-intl';

export default defineMessages({
  save: {
    id: 'cboard.components.FormDialog.save',
    defaultMessage: 'Save'
  },
  cancel: {
    id: 'cboard.components.FormDialog.cancel',
    defaultMessage: 'Cancel'
  }
});
